import { useGlobalContext } from "app/store/GlobalContext";

type Props = {
  onLogout: () => void;
};

export default function LogoutButton({ onLogout }: Props) {
  const { handleNavigation } = useGlobalContext();

  const handleClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.preventDefault();
    handleNavigation({
      url: "/",
      eventTitle: "",
      clickEvent: () => onLogout(),
      shouldHardRedirect: true,
    });
  };

  return (
    <span
      id="logoutButton"
      className="clickable"
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick(e);
      }}
    >
      Logga ut
    </span>
  );
}
